import React from 'react';
import { isIncluded } from './editorState';
import { modelUses, canRetireModel } from './operationsState';

export default function ModelRetirementStatus({ published, catalog, model, dirty, onPlacement, onModels, busy }) {
  const uses = modelUses(published, model);
  const current = modelUses(catalog, model).published;
  const publishedActive = uses.published.filter(p => p.active);
  const draftActive = uses.draft.filter(p => p.active);
  const publishedBundle = isIncluded(published, model);
  const draftBundle = isIncluded({ bundleSelection: published.operations?.draftBundle ?? published.bundleSelection }, model);
  const blocked = !canRetireModel(published, model);
  const placements = [...new Map([...publishedActive, ...draftActive].map(p => [p.id, p])).values()];
  return <section className="lm-retirement-status" aria-label="모델 삭제 조건">
    <h4>{blocked || dirty ? '삭제 전 필요한 작업' : '삭제할 수 있습니다'}</h4>
    <ul>
      <li>현재 게시본: 활성 배치 {publishedActive.length}곳 · 다음 빌드 {publishedBundle ? '포함' : '제외'}</li>
      <li>저장된 초안: 활성 배치 {draftActive.length}곳 · 다음 빌드 {draftBundle ? '포함' : '제외'}</li>
    </ul>
    {placements.map(p => {
      const working = current.find(item => item.id === p.id);
      return <div key={p.id} className="lm-retirement-placement">
        <strong>{p.name} <small>({p.id})</small></strong>
        {working?.active ? <><p>편집 초안에서 이 배치를 중단하거나 삭제한 뒤 초안을 저장하고 게시하세요.</p><button type="button" className="lm-button lm-button--secondary" disabled={busy} onClick={() => onPlacement(p.id)}>배치 설정으로 이동</button></>
          : <p>{dirty ? '편집 초안에서 중단·삭제했습니다. 초안 저장 → 게시가 필요합니다.' : '저장된 초안에서 중단·삭제했습니다. 게시 검토 → 게시가 필요합니다.'}</p>}
      </div>;
    })}
    {(publishedBundle || draftBundle) && <div>
      <p>{isIncluded(catalog, model) ? '모델 목록에서 다음 빌드 포함을 해제한 뒤 초안을 저장하고 게시하세요.' : dirty ? '빌드 제외를 편집했습니다. 초안 저장 → 게시가 필요합니다.' : '저장된 초안은 빌드 제외 상태입니다. 게시 검토 → 게시가 필요합니다.'}</p>
      {isIncluded(catalog, model) && <button type="button" className="lm-button lm-button--secondary" disabled={busy} onClick={onModels}>빌드 포함 설정으로 이동</button>}
    </div>}
    {dirty && <p role="status">저장하지 않은 변경이 있습니다. 먼저 초안을 저장하거나 변경을 취소해 주세요.</p>}
    {!blocked && <p>중단된 배치 참조는 삭제를 막지 않습니다. 삭제할 때 함께 제거됩니다.</p>}
    {(blocked || dirty) && <p>확인 문구를 입력해도 위 조건이 해결되기 전에는 삭제할 수 없습니다.</p>}
  </section>;
}
